const DEFAULT_SATELLITE_API_ORIGIN = 'https://satellite.hotpads.com';
const HOTPADS_API_BASE_PATH = '/hotpads-api/api';

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function stripHotpadsApiSuffix(value: string): string {
  if (value.endsWith(HOTPADS_API_BASE_PATH)) {
    return value.slice(0, -HOTPADS_API_BASE_PATH.length);
  }

  if (value.endsWith('/hotpads-api')) {
    return value.slice(0, -'/hotpads-api'.length);
  }

  return value;
}

export function getServerApiOrigin(): string {
  const configured = process.env.ZG_API;
  if (!configured) {
    throw new Error('ZG_API must be set');
  }
  return stripHotpadsApiSuffix(trimTrailingSlash(configured));
}

export function getCmsGraphUrl(): string {
  const configured = process.env.WP_GRAPHQL;
  if (!configured) {
    throw new Error('WP_GRAPHQL must be set');
  }
  return configured;
}

export function getSatelliteApiOrigin(): string {
  return trimTrailingSlash(process.env.ZG_SATELLITE_API || DEFAULT_SATELLITE_API_ORIGIN);
}

export function getServerApiBaseUrl(): string {
  const origin = getServerApiOrigin();

  if (origin.endsWith(HOTPADS_API_BASE_PATH)) {
    return origin;
  }

  if (origin.endsWith('/hotpads-api')) {
    return `${origin}/api`;
  }

  return `${origin}${HOTPADS_API_BASE_PATH}`;
}
